import React, { useEffect, useMemo, useState } from 'react'
import { Modal, ModalBody } from "react-bootstrap";
import { useSelector } from 'react-redux';
// import { noteTypes } from '../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/Components/Constants';

const PrintOutSelectDataModal = ({ printoutSelectDataModal, setPrintoutSelectDataModal, setPrintoutModal,
     selectedItemsSOAP, selectedItemsGIRP, selectedItemsBIRP, selectedItemsDAP, selectedItemsDAPP, selectedItemsTherapy, selectedItemsMassage, selectedItemsPhysical,  selectedItemsOther,   selectedItemsCustomNote, selectedItemsUIView,
     setSelectedItemsSOAP, setSelectedItemsGIRP, setSelectedItemsBIRP, setSelectedItemsDAP, setSelectedItemsDAPP, setSelectedItemsTherapy, setSelectedItemsMassage, setSelectedItemsPhysical, setSelectedItemsOther, setSelectedItemsCustomNote, setSelectedItemsUIView, noteTypeSet, ...props }) => {

    let {
        showAddressTypeLocationSOAP,
        setShowAddressTypeLocationSOAP,

        showAddressTypeLocationGIRP,
        setShowAddressTypeLocationGIRP,

        showAddressTypeLocationBIRP,
        setShowAddressTypeLocationBIRP,

        showAddressTypeLocationDAP,
        setShowAddressTypeLocationDAP,

        showAddressTypeLocationDAPP,
        setShowAddressTypeLocationDAPP,

        showAddressTypeLocationTherapy,
        setShowAddressTypeLocationTherapy,

        showAddressTypeLocationMassage,
        setShowAddressTypeLocationMassage,

        showAddressTypeLocationPhysical,
        setShowAddressTypeLocationPhysical,

        showAddressTypeLocationOther,
        setShowAddressTypeLocationOther,

        showAddressTypeLocationCustomNote,
        setShowAddressTypeLocationCustomNote,

        id,
    } = props;
    
    const DEFAULT_SELECTED_CUSTOMNOTE = {
        patientSummary: true,
        mainCustomTemplateClinical: true,
    };

    const checklistStructureSOAP = {
        "customTemplateClinical": [],
        subjective: ["chiefComplaint", "historyofPresentIllness", "reviewOfSystem", "subjectiveNotes"],
        objective: ["vitals", "observations", "objectiveNotes"],
        assessment: ["problems", "assessmentNotes"],
        plan: [ "prescriptions", "supplements", "vaccines", "injections", "labs", "imaging", "planNotes", "followUp"],
        additionalInfo: ["documents", "additionalNotes"],
        procedureCodes :[]
    }; 
    const checklistStructureGIRP = {
        'patientSummary': [] ,
        "customTemplateClinical": [],
        'chiefComplaint': [] ,
        'historyofPresentIllness': [] ,
        'reviewOfSystem': [] ,
        'problems': [],
        'goalsNotes': [],
        'interventionNotes': [],
        'responseNotes': [],
        'plan': [ "prescriptions", "supplements", "vaccines", "injections", "labs", "imaging", "planNotes", "followUp"],
        'additionalInfo': ["documents", "additionalNotes"],
        'procedureCodes':[]
    } 
    const checklistStructureBIRP = {
        'patientSummary': [] ,
        "customTemplateClinical": [],
        'chiefComplaint': [] ,
        'historyofPresentIllness': [] ,
        'reviewOfSystem': [] ,
        'problems': [],
        'behaviourNotes': [],
        'interventionNotes': [],
        'responseNotes': [],
        'plan': [ "prescriptions", "supplements", "vaccines", "injections", "labs", "imaging", "planNotes", "followUp"],
        'additionalInfo': ["documents", "additionalNotes"],
        'procedureCodes':[]
    } 
    const checklistStructureDAP = {
        'patientSummary': [] ,
        "customTemplateClinical": [],
        'chiefComplaint': [] ,
        'historyofPresentIllness': [] ,
        'reviewOfSystem': [] ,
        'problems': [],
        'dataNotes': [],
        'assessmentNotes': [],
        'plan': [ "prescriptions", "supplements", "vaccines", "injections", "labs", "imaging", "planNotes", "followUp"],
        'additionalInfo': ["documents", "additionalNotes"],
        'procedureCodes':[]
    } 
    const checklistStructureDAPP = {
        'patientSummary': [] ,
        "customTemplateClinical": [],
        'chiefComplaint': [] ,
        'historyofPresentIllness': [] ,
        'reviewOfSystem': [] ,
        'problems': [],
        'dataNotes': [],
        'assessmentNotes': [],
        'progressNotes': [],
        'plan': [ "prescriptions", "supplements", "vaccines", "injections", "labs", "imaging", "planNotes", "followUp"],
        'additionalInfo': ["documents", "additionalNotes"],
        'procedureCodes':[]
    } 
    const checklistStructureTherapy = {
        'patientSummary': [] ,
        "customTemplateClinical": [],
        'chiefComplaint': [] ,
        'historyofPresentIllness': [] ,
        'reviewOfSystem': [] ,
        'problems': [],
        'objective': ["currentMentalStatus", "objectiveNotes"],
        'intervention': ["interventionNotes", "interventionsUsed"],
        'response': [ "responseNotes", "responseObservations"],
        'assessment': ["riskAssessment", "assessmentNotes"],
        'plan': [ "prescriptions", "supplements", "vaccines", "injections", "labs", "imaging", "planNotes", "followUp"],
        'additionalInfo': ["documents", "additionalNotes"],
        'procedureCodes':[]
    } 
    const checklistStructureMassage = {
        'patientSummary': [],
        "customTemplateClinical": [],
        'chiefComplaint':[],
        'problems':[],
        'subjectiveNotes': [],
        'objective': ["objectiveFindings", "objectiveNotes"],
        'assessment': ["assessmentAreaTreated", "focusArea", "assessmentMethodUsed", "assessmentNotes"],
        'plan': ["planNotes", "homeExerciseProgram", "followUp"],
        'additionalInfo': ["documents", "additionalNotes"],
        'procedureCodes': []
    } 
    const checklistStructurePhysical = {
        'patientSummary': [],
        "customTemplateClinical": [],
        'chiefComplaint':[],
        'problems':[],
        'subjectiveNotes': [],
        'objective': ["observationNotes", "problemArea","palpationNotes", "rangeOfMotion", "strength", "testMeasurementNotes", "objectiveNotes"],
        'assessment': [],
        'plan': ["planNotes", "homeExerciseProgram", "followUp"],
        'additionalInfo': ["documents", "additionalNotes"],
        'procedureCodes': []
    } 
    const checklistStructureOther = {
        'patientSummary': [] ,
        "customTemplateClinical": [],
        'chiefComplaint': [] ,
        'historyofPresentIllness': [] ,
        'reviewOfSystem': [] ,
        'vitals': [],
        'problems': [],
        'otherNote': [],
        'followUp': [],
        // 'documents': [],
        'additionalInfo': ["documents", "additionalNotes"],
        'procedureCodes': [],
    };
    const checklistStructureCustomNote = {
        'patientSummary': [] ,
        "customTemplateClinical": [],
        'mainCustomTemplateClinical': [] ,
    };
    const allKeysSOAP = [
        "patientSummary",
        'customTemplateClinical',
        "subjective",
        "chiefComplaint",
        "historyofPresentIllness",
        "reviewOfSystem",
        "subjectiveNotes",
        "objective",
        "vitals",
        "observations",
        "objectiveNotes",
        "assessment",
        "problems",
        "assessmentNotes",
        "plan",
        "prescriptions", "supplements", "vaccines", "injections", "labs", "imaging",
        "planNotes",
        "followUp",
        "additionalInfo",
        "documents",
        "additionalNotes",
        "procedureCodes",
    ] ;
    const allKeysGIRP  = [
        "patientSummary",
        'customTemplateClinical',
        "chiefComplaint",
        "historyofPresentIllness",
        "reviewOfSystem",
        "problems",
        "goalsNotes",
        "interventionNotes",
        "responseNotes",
        "plan",
        "prescriptions", "supplements", "vaccines", "injections", "labs", "imaging",
        "planNotes",
        "followUp",
        "additionalInfo",
        "documents",
        "additionalNotes",
        "procedureCodes",
    ] ;
    const allKeysBIRP  = [
        "patientSummary",
        'customTemplateClinical',
        "chiefComplaint",
        "historyofPresentIllness",
        "reviewOfSystem",
        "problems",
        "behaviourNotes",
        "interventionNotes",
        "responseNotes",
        "plan",
        "prescriptions", "supplements", "vaccines", "injections", "labs", "imaging",
        "planNotes",
        "followUp",
        "additionalInfo",
        "documents",
        "additionalNotes",
        "procedureCodes",
    ] ;
    const allKeysDAP  = [
        "patientSummary",
        'customTemplateClinical',
        "chiefComplaint",
        "historyofPresentIllness",
        "reviewOfSystem",
        "problems",
        "dataNotes",
        "assessmentNotes",
        "plan",
        "prescriptions", "supplements", "vaccines", "injections", "labs", "imaging",
        "planNotes",
        "followUp",
        "additionalInfo",
        "documents",
        "additionalNotes",
        "procedureCodes",
    ] ;
    const allKeysDAPP  = [
        "patientSummary",
        'customTemplateClinical',
        "chiefComplaint",
        "historyofPresentIllness",
        "reviewOfSystem",
        "problems",
        "dataNotes",
        "assessmentNotes",
        "progressNotes",
        "plan",
        "prescriptions", "supplements", "vaccines", "injections", "labs", "imaging",
        "planNotes",
        "followUp",
        "additionalInfo",
        "documents",
        "additionalNotes",
        "procedureCodes",
    ] ;
    const allKeysTherapy  = [
        "patientSummary",
        'customTemplateClinical',
        "chiefComplaint",
        "historyofPresentIllness",
        "reviewOfSystem",
        "problems",
        "objective",
        "currentMentalStatus", 
        "objectiveNotes",
        "intervention",
        "interventionNotes", 
        "interventionsUsed",
        "response", 
        "responseNotes", 
        "responseObservations",
        "assessment",
        "riskAssessment", 
        "assessmentNotes",
        "plan",
        "prescriptions", "supplements", "vaccines", "injections", "labs", "imaging",
        "planNotes",
        "followUp",

        "additionalInfo",
        "documents",
        "additionalNotes",
        "procedureCodes",
    ] ;
    const allKeysMassage  = [
        "patientSummary",
        'customTemplateClinical',
        "chiefComplaint",
        "subjectiveNotes",
        "problems",
        "objective",
        "objectiveFindings",
        "objectiveNotes",
        "assessment",
        "assessmentAreaTreated", 
        "focusArea", 
        "assessmentMethodUsed",
        "assessmentNotes",
        "plan",
        "planNotes",
        "homeExerciseProgram",
        "followUp",
        "additionalInfo",
        "documents",
        "additionalNotes",
        "procedureCodes",
    ] ;
    const allKeysPhysical  = [
        "patientSummary",
        'customTemplateClinical',
        "chiefComplaint",
        "problems",
        "subjectiveNotes",
        "objective",
        "observationNotes", "problemArea","palpationNotes", "rangeOfMotion", "strength", "testMeasurementNotes", "objectiveNotes",
        "assessment",
        "plan",
        "planNotes",
        "homeExerciseProgram",
        "followUp",
        "additionalInfo",
        "documents",
        "additionalNotes",
        "procedureCodes",
    ] ;
    const allKeysOther   = [
        "patientSummary",
        'customTemplateClinical',
        "chiefComplaint",
        "historyofPresentIllness",
        "reviewOfSystem",
        "vitals",
        "objectiveNotes",
        "problems",
        "otherNote",
        "followUp",
        "additionalInfo",
        "documents",
        "additionalNotes",
        "procedureCodes",
    ];
    const allKeysCustomNote  = [
        "patientSummary",
        'customTemplateClinical',
        "mainCustomTemplateClinical"
        // "chiefComplaint",
        // "historyofPresentIllness",
        // "reviewOfSystem",
        // "vitals",
        // "objectiveNotes",
        // "problems",
        // "otherNote",
        // "followUp",
        // "additionalInfo",
        // "documents",
        // "additionalNotes",
        // "procedureCodes",
    ];
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    const[activeAccord, setActiveAccord] = useState('');
    // console.log("noteTypeSet Remaining Custom Notes",noteTypes.map(it => it.value).find(note => noteTypeSet.has(note)), noteTypes, noteTypeSet)

    const getCurrentStructure = () => {
        if (activeAccord === "SOAP") return checklistStructureSOAP;
        else if (activeAccord === "GIRP") return checklistStructureGIRP;
        else if (activeAccord === "BIRP") return checklistStructureBIRP;
        else if (activeAccord === "DAP") return checklistStructureDAP;
        else if (activeAccord === "DAPP") return checklistStructureDAPP;
        else if (activeAccord === "Therapy") return checklistStructureTherapy;
        else if (activeAccord === "Massage") return checklistStructureMassage;
        else if (activeAccord === "Physical") return checklistStructurePhysical;
        else if (activeAccord === "Other") return checklistStructureOther;
        // else if (activeAccord === "CustomNote") return checklistStructureCustomNote;
        else return checklistStructureCustomNote;
    };
    const getParentKey = (childKey) => {
        const structure = getCurrentStructure();
        for (const [parent, children] of Object.entries(structure)) {
            if (children.includes(childKey)) return parent;
        }
        return null;
    };

    const toggleItem = (key) => {
        if (activeAccord === "SOAP") {
            setSelectedItemsSOAP(prev => {
                const updated = { ...prev };
                const isNowChecked = !prev[key];

                if (checklistStructureSOAP[key]) {
                    updated[key] = isNowChecked;
                    checklistStructureSOAP[key].forEach(child => {
                        updated[child] = isNowChecked;
                    });
                } else {
                    updated[key] = isNowChecked;
                    const parent = getParentKey(key);
                    if (parent) {
                        const allChildren = checklistStructureSOAP[parent];
                        const allChecked = allChildren.every(c => 
                            c === key ? isNowChecked : prev[c]
                        );
                        updated[parent] = allChecked;
                    }
                }

                return updated;
            });
        } else if (activeAccord === "GIRP") {
            setSelectedItemsGIRP(prev => {
                const updated = { ...prev };
                const isNowChecked = !prev[key];

                if (checklistStructureGIRP[key]) {
                    updated[key] = isNowChecked;
                    checklistStructureGIRP[key].forEach(child => {
                        updated[child] = isNowChecked;
                    });
                } else {
                    updated[key] = isNowChecked;
                    const parent = getParentKey(key);
                    if (parent) {
                        const allChildren = checklistStructureGIRP[parent];
                        const allChecked = allChildren.every(c => 
                            c === key ? isNowChecked : prev[c]
                        );
                        updated[parent] = allChecked;
                    }
                }

                return updated;
            });
        } else if (activeAccord === "BIRP") {
            setSelectedItemsBIRP(prev => {
                const updated = { ...prev };
                const isNowChecked = !prev[key];

                if (checklistStructureBIRP[key]) {
                    updated[key] = isNowChecked;
                    checklistStructureBIRP[key].forEach(child => {
                        updated[child] = isNowChecked;
                    });
                } else {
                    updated[key] = isNowChecked;
                    const parent = getParentKey(key);
                    if (parent) {
                        const allChildren = checklistStructureBIRP[parent];
                        const allChecked = allChildren.every(c => 
                            c === key ? isNowChecked : prev[c]
                        );
                        updated[parent] = allChecked;
                    }
                }

                return updated;
            });
        } else if (activeAccord === "DAP") {
            setSelectedItemsDAP(prev => {
                const updated = { ...prev };
                const isNowChecked = !prev[key];

                if (checklistStructureDAP[key]) {
                    updated[key] = isNowChecked;
                    checklistStructureDAP[key].forEach(child => {
                        updated[child] = isNowChecked;
                    });
                } else {
                    updated[key] = isNowChecked;
                    const parent = getParentKey(key);
                    if (parent) {
                        const allChildren = checklistStructureDAP[parent];
                        const allChecked = allChildren.every(c => 
                            c === key ? isNowChecked : prev[c]
                        );
                        updated[parent] = allChecked;
                    }
                }

                return updated;
            });
        } else if (activeAccord === "DAPP") {
            setSelectedItemsDAPP(prev => {
                const updated = { ...prev };
                const isNowChecked = !prev[key];

                if (checklistStructureDAPP[key]) {
                    updated[key] = isNowChecked;
                    checklistStructureDAPP[key].forEach(child => {
                        updated[child] = isNowChecked;
                    });
                } else {
                    updated[key] = isNowChecked;
                    const parent = getParentKey(key);
                    if (parent) {
                        const allChildren = checklistStructureDAPP[parent];
                        const allChecked = allChildren.every(c => 
                            c === key ? isNowChecked : prev[c]
                        );
                        updated[parent] = allChecked;
                    }
                }

                return updated;
            });
        } else if (activeAccord === "Therapy") {
            setSelectedItemsTherapy(prev => {
                const updated = { ...prev };
                const isNowChecked = !prev[key];

                if (checklistStructureTherapy[key]) {
                    updated[key] = isNowChecked;
                    checklistStructureTherapy[key].forEach(child => {
                        updated[child] = isNowChecked;
                    });
                } else {
                    updated[key] = isNowChecked;
                    const parent = getParentKey(key);
                    if (parent) {
                        const allChildren = checklistStructureTherapy[parent];
                        const allChecked = allChildren.every(c => 
                            c === key ? isNowChecked : prev[c]
                        );
                        updated[parent] = allChecked;
                    }
                }

                return updated;
            });
        } else if (activeAccord === "Massage") {
            setSelectedItemsMassage(prev => {
                const updated = { ...prev };
                const isNowChecked = !prev[key];

                if (checklistStructureMassage[key]) {
                    updated[key] = isNowChecked;
                    checklistStructureMassage[key].forEach(child => {
                        updated[child] = isNowChecked;
                    });
                } else {
                    updated[key] = isNowChecked;
                    const parent = getParentKey(key);
                    if (parent) {
                        const allChildren = checklistStructureMassage[parent];
                        const allChecked = allChildren.every(c => 
                            c === key ? isNowChecked : prev[c]
                        );
                        updated[parent] = allChecked;
                    }
                }

                return updated;
            });
        } else if (activeAccord === "Physical") {
            setSelectedItemsPhysical(prev => {
                const updated = { ...prev };
                const isNowChecked = !prev[key];

                if (checklistStructurePhysical[key]) {
                    updated[key] = isNowChecked;
                    checklistStructurePhysical[key].forEach(child => {
                        updated[child] = isNowChecked;
                    });
                } else {
                    updated[key] = isNowChecked;
                    const parent = getParentKey(key);
                    if (parent) {
                        const allChildren = checklistStructurePhysical[parent];
                        const allChecked = allChildren.every(c => 
                            c === key ? isNowChecked : prev[c]
                        );
                        updated[parent] = allChecked;
                    }
                }

                return updated;
            });
        } else if (activeAccord === "Other") {
            setSelectedItemsOther(prev => {
                const updated = { ...prev };
                const isNowChecked = !prev[key];

                if (checklistStructureOther[key]) {
                    updated[key] = isNowChecked;
                    checklistStructureOther[key].forEach(child => {
                        updated[child] = isNowChecked;
                    });
                } else {
                    updated[key] = isNowChecked;
                    const parent = getParentKey(key);
                    if (parent) {
                        const allChildren = checklistStructureOther[parent];
                        const allChecked = allChildren.every(c => 
                            c === key ? isNowChecked : prev[c]
                        );
                        updated[parent] = allChecked;
                    }
                }

                return updated;
            });
        } else if(filteredRemainingCustomNotes.includes(activeAccord)){
            setSelectedItemsCustomNote(prev => {
                const noteState = prev?.[activeAccord] || {};
                // console.log("noteState",noteState)
                const updated = { ...noteState };

                const isNowChecked = !noteState[key];

                if (checklistStructureCustomNote[key]) {
                    updated[key] = isNowChecked;
                    checklistStructureCustomNote[key].forEach(child => {
                        updated[child] = isNowChecked;
                    });
                } else {
                    updated[key] = isNowChecked;
                    const parent = getParentKey(key);

                    if (parent) {
                        const allChildren = checklistStructureCustomNote[parent];
                        const allChecked = allChildren.every(c => c === key ? isNowChecked : noteState[c] );
                        updated[parent] = allChecked;
                    }
                }
                return { ...prev, [activeAccord]: updated
                };
            });
        }
    };

    const selectAll = (noteType = activeAccord) => {
        if (noteType === 'SOAP') {
            const allChecked = allKeysSOAP.reduce((acc, key) => {
                acc[key] = true;
                return acc;
            }, {});
            setSelectedItemsSOAP(prev => ({ ...allChecked, uiDesign: prev?.uiDesign ?? false }));
        } else if (noteType === 'GIRP') {
            const allChecked = allKeysGIRP.reduce((acc, key) => {
                acc[key] = true;
                return acc;
            }, {});
            setSelectedItemsGIRP(prev => ({ ...allChecked, uiDesign: prev?.uiDesign ?? false }));
        } else if (noteType === 'BIRP') {
            const allChecked = allKeysBIRP.reduce((acc, key) => {
                acc[key] = true;
                return acc;
            }, {});
            setSelectedItemsBIRP(prev => ({ ...allChecked, uiDesign: prev?.uiDesign ?? false }));
        } else if (noteType === 'DAP') {
            const allChecked = allKeysDAP.reduce((acc, key) => {
                acc[key] = true;
                return acc;
            }, {});
            setSelectedItemsDAP(prev => ({ ...allChecked, uiDesign: prev?.uiDesign ?? false }));
        } else if (noteType === 'DAPP') {
            const allChecked = allKeysDAPP.reduce((acc, key) => {
                acc[key] = true;
                return acc;
            }, {});
            setSelectedItemsDAPP(prev => ({ ...allChecked, uiDesign: prev?.uiDesign ?? false }));
        } else if (noteType === 'Therapy') {
            const allChecked = allKeysTherapy.reduce((acc, key) => {
                acc[key] = true;
                return acc;
            }, {});
            setSelectedItemsTherapy(prev => ({ ...allChecked, uiDesign: prev?.uiDesign ?? false }));
        } else if (noteType === 'Massage') {
            const allChecked = allKeysMassage.reduce((acc, key) => {
                acc[key] = true;
                return acc;
            }, {});
            setSelectedItemsMassage(prev => ({ ...allChecked, uiDesign: prev?.uiDesign ?? false }));
        } else if (noteType === 'Physical') {
            const allChecked = allKeysPhysical.reduce((acc, key) => {
                acc[key] = true;
                return acc;
            }, {});
            setSelectedItemsPhysical(prev => ({ ...allChecked, uiDesign: prev?.uiDesign ?? false }));
        } else if (noteType === 'Other') {
            const allChecked = allKeysOther.reduce((acc, key) => {
                acc[key] = true;
                return acc;
            }, {});
            setSelectedItemsOther(prev => ({ ...allChecked, uiDesign: prev?.uiDesign ?? false }));
        } else if (filteredRemainingCustomNotes.includes(noteType)){
            const allChecked = allKeysCustomNote.reduce((acc, key) => {
                acc[key] = true;
                return acc;
            }, {});

            setSelectedItemsCustomNote(prev => ({
                ...prev,
                [noteType]: {
                    ...allChecked,
                    uiDesign: prev?.[noteType]?.uiDesign ?? false
                }
            }));
        }
    };
    // Optional: for Proceed button
    const handleProceed = () => {
        const selected = Object.entries(selectedItemsSOAP)
            .filter(([_, val]) => val)
            .map(([key]) => key);

        // console.log("Selected Items:", selected);
        // pass `selected` to next modal

        // const allUnChecked = allKeys.reduce((acc, key) => {
        // acc[key] = false;
        // return acc;
        // }, {});
        // setSelectedItems(allUnChecked);

        setPrintoutModal(true);
        setPrintoutSelectDataModal(false);
        // console.log("select End")
    };

    // useEffect(() => {
    //     const match = noteTypes.map(it => it.value).find(note => noteTypeSet.has(note));

    //     if (match) setActiveAccord(match);
    // },[noteTypeSet]);
    
    const filteredRemainingCustomNotes = useMemo(() => {
        return [...noteTypeSet].filter(note => {
            const noteObj = noteTypes.find(it => it.value === note);
            return !noteObj?.IsSystemGenerated;
        });
    }, [noteTypeSet]);

    const getDefaultCustomNoteState = () => ({
        ...DEFAULT_SELECTED_CUSTOMNOTE
    }); 

    useEffect(() => {
        // console.log("useEffect",filteredRemainingCustomNotes)
        setSelectedItemsCustomNote(prev => {
            const updated = { ...prev };
            filteredRemainingCustomNotes.forEach(noteType => {
                if (!updated[noteType]) {
                    updated[noteType] = getDefaultCustomNoteState();
                }
            });
            return updated;
        });
        setShowAddressTypeLocationCustomNote(prev => {
            const updated = { ...prev };
            filteredRemainingCustomNotes.forEach(noteType => {
                if (!updated[noteType]) {
                    updated[noteType] = "false";
                }
            });
            return updated;
        })

        const systemNotes = [...noteTypeSet].filter(note => {
            const noteObj = noteTypes.find(it => it.value === note);
            return noteObj?.IsSystemGenerated;
        });

        const firstSystem = systemNotes[0];
        const firstCustom = filteredRemainingCustomNotes[0];

        const nextActive = firstSystem || firstCustom || "";
        setActiveAccord(nextActive)
    }, []);

    const handleAccord = note => setActiveAccord(prev => prev === note ? '' : note);

    return (
        <>
            <Modal show={printoutSelectDataModal} onHide={printoutSelectDataModal} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_print_encounter_summary ar_bulk_print_popup">
                <Modal.Body>
                    {/* <ModalHeader HeaderName={EncounterName} DeletePopup={''} isClosed={() => setPrintoutSelectDataModal(false)} /> */}
                    <>
                    <div className="d-flex align-items-center justify-content-between mb-12 px-10">
                        <div className="">
                            <p className="heading dark-clr fs-14 lh-normal">Bulk Print Setting</p>
                        </div>
                        <i className="icon-x-cros fs-20 dark-clr" onClick={() => setPrintoutSelectDataModal(false)}></i>
                    </div>
                    <div className="d-flex flex-column gap-12 scroll-content hover-scrollbar px-10">
                        {noteTypeSet.has('SOAP') ? 
                        <div>
                            <div className="d-flex justify-content-between align-items-center br-bottom-1 za_br_light pb-1-5">
                                <div className="d-flex align-items-center gap-6 cursor-pointer" onClick={() => handleAccord("SOAP")}>
                                    <i className={`${activeAccord === "SOAP" ? 'icon-up' : 'icon-down'} fs-10`}></i>
                                    <p className="heading user-select-none">SOAP Note</p>
                                </div>
                                <p
                                    className="heading validate-color cursor-pointer user-select-none"
                                    onClick={() => selectAll('SOAP')}
                                >
                                    Select All
                                </p>
                            </div>
                            {activeAccord === "SOAP" &&
                            <div className="d-flex gap-15 justify-content-between mt-2">
                                <div className="d-flex flex-column row-gap-12">
                                    {/* Patient Summary */}
                                    <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsSOAP["patientSummary"]}
                                                    onChange={() => toggleItem("patientSummary")}
                                                />
                                            </div>
                                            <p className="text fs-13">Patient Address</p>
                                        </label>
                                        {!!selectedItemsSOAP["patientSummary"] ?
                                            <div className="child d-flex flex-column gap-2">
                                                <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                    <input
                                                    type="radio"
                                                    id={`address-false-${id}-SOAP`}
                                                    name={`ShowPatientsData-${id}-SOAP`}
                                                    value="false"
                                                    checked={showAddressTypeLocationSOAP === 'false'}
                                                    onChange={(e) => setShowAddressTypeLocationSOAP(e.target.value)}
                                                    />
                                                    <label className="text ar-orange-text text-nowrap" htmlFor={`address-false-${id}-SOAP`}>Patient Address</label>
                                                </div>
                                                <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                    <input
                                                    type="radio"
                                                    id={`address-true-${id}-SOAP`}
                                                    name={`ShowPatientsData-${id}-SOAP`}
                                                    value="true"
                                                    checked={showAddressTypeLocationSOAP === 'true'}
                                                    onChange={(e) => setShowAddressTypeLocationSOAP(e.target.value)} 
                                                    />
                                                    <label className="text ar-orange-text text-nowrap" htmlFor={`address-true-${id}-SOAP`}>Location Address</label>
                                                </div>
                                            </div> : <></>}
                                    </div>
                                    
                                    {/* "Custom Template Clinical" */}
                                    <div>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsSOAP["customTemplateClinical"]}
                                                    onChange={() => toggleItem("customTemplateClinical")}
                                                />
                                            </div>
                                            <p className="text fs-13">Custom Template Clinical</p>
                                        </label>
                                    </div>

                                    {/* Subjective */}
                                    <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsSOAP["subjective"]}
                                                    onChange={() => toggleItem("subjective")}
                                                />
                                            </div>
                                            <p className="text fs-13">Subjective</p>
                                        </label>
                                        <div className="child d-flex flex-column gap-2">
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["chiefComplaint"]}
                                                        onChange={() => toggleItem("chiefComplaint")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Chief Complaint</p>
                                            </label>
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["historyofPresentIllness"]}
                                                        onChange={() => toggleItem("historyofPresentIllness")}
                                                    />
                                                </div>
                                                <p className="text fs-13">History of Present Illness</p>
                                            </label>
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["reviewOfSystem"]}
                                                        onChange={() => toggleItem("reviewOfSystem")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Review Of System</p>
                                            </label>
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["subjectiveNotes"]}
                                                        onChange={() => toggleItem("subjectiveNotes")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Notes</p>
                                            </label>
                                        </div>
                                    </div>

                                    {/* Objective */}
                                    <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsSOAP["objective"]}
                                                    onChange={() => toggleItem("objective")}
                                                />
                                            </div>
                                            <p className="text fs-13">Objective</p>
                                        </label>
                                        <div className="child d-flex flex-column gap-2">
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["vitals"]}
                                                        onChange={() => toggleItem("vitals")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Vitals</p>
                                            </label>
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["observations"]}
                                                        onChange={() => toggleItem("observations")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Observations</p>
                                            </label>
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["objectiveNotes"]}
                                                        onChange={() => toggleItem("objectiveNotes")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Notes</p>
                                            </label>
                                        </div>
                                    </div>

                                    {/* Assessment */}
                                    <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsSOAP["assessment"]}
                                                    onChange={() => toggleItem("assessment")}
                                                />
                                            </div>
                                            <p className="text fs-13">Assessment</p>
                                        </label>
                                        <div className="child d-flex flex-column gap-2">
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["problems"]}
                                                        onChange={() => toggleItem("problems")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Problems</p>
                                            </label>
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["assessmentNotes"]}
                                                        onChange={() => toggleItem("assessmentNotes")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Notes</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                {/* Right Column */}
                                <div className="d-flex flex-column row-gap-12">
                                    {/* Plan */}
                                    <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsSOAP["plan"]}
                                                    onChange={() => toggleItem("plan")}
                                                />
                                            </div>
                                            <p className="text fs-13">Plan</p>
                                        </label>
                                        <div className="child d-flex flex-column gap-2">
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["prescriptions"]}
                                                        onChange={() => toggleItem("prescriptions")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Prescriptions</p>
                                            </label>
                                        </div>
                                        <div className="child d-flex flex-column gap-2">
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["supplements"]}
                                                        onChange={() => toggleItem("supplements")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Supplements</p>
                                            </label>
                                        </div>
                                        <div className="child d-flex flex-column gap-2">
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["vaccines"]}
                                                        onChange={() => toggleItem("vaccines")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Vaccines</p>
                                            </label>
                                        </div>
                                        <div className="child d-flex flex-column gap-2">
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["injections"]}
                                                        onChange={() => toggleItem("injections")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Injections</p>
                                            </label>
                                        </div>
                                        <div className="child d-flex flex-column gap-2">
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["labs"]}
                                                        onChange={() => toggleItem("labs")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Labs</p>
                                            </label>
                                        </div>
                                        <div className="child d-flex flex-column gap-2">
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["imaging"]}
                                                        onChange={() => toggleItem("imaging")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Imaging</p>
                                            </label>
                                        </div>
                                        <div className="child d-flex flex-column gap-2">
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["planNotes"]}
                                                        onChange={() => toggleItem("planNotes")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Notes</p>
                                            </label>
                                        </div>
                                        <div className="child d-flex flex-column gap-2">
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["followUp"]}
                                                        onChange={() => toggleItem("followUp")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Follow-Up</p>
                                            </label>
                                        </div>
                                    </div>

                                    {/* Additional Info */}
                                    <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsSOAP["additionalInfo"]}
                                                    onChange={() => toggleItem("additionalInfo")}
                                                />
                                            </div>
                                            <p className="text fs-13">Additional Info</p>
                                        </label>
                                        <div className="child d-flex flex-column gap-2">
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["documents"]}
                                                        onChange={() => toggleItem("documents")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Documents</p>
                                            </label>
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsSOAP["additionalNotes"]}
                                                        onChange={() => toggleItem("additionalNotes")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Notes</p>
                                            </label>
                                        </div>
                                    </div>
                                    
                                    {/* Procedure Codes */}
                                    <div>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsSOAP["procedureCodes"]}
                                                    onChange={() => toggleItem("procedureCodes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Procedure Codes</p>
                                        </label>
                                    </div>
                                    
                                </div>
                            </div>}
                        </div> : <></>}

                        {noteTypeSet.has('GIRP') ? 
                        <div>
                            <div className="d-flex justify-content-between align-items-center br-bottom-1 za_br_light pb-1-5">
                                <div className="d-flex align-items-center gap-6 cursor-pointer" onClick={() => handleAccord("GIRP")}>
                                    <i className={`${activeAccord === "GIRP" ? 'icon-up' : 'icon-down'} fs-10`}></i>
                                    <p className="heading user-select-none">GIRP Note</p>
                                </div>
                                <p
                                    className="heading validate-color cursor-pointer user-select-none"
                                    onClick={() => selectAll('GIRP')}
                                >
                                    Select All
                                </p>
                            </div>  
                        {activeAccord === "GIRP" &&
                        <div className="d-flex gap-15 justify-content-between mt-2">
                            <div className="d-flex flex-column row-gap-12">
                                {/* Patient Summary */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsGIRP["patientSummary"]}
                                                onChange={() => toggleItem("patientSummary")}
                                            />
                                        </div>
                                        <p className="text fs-13">Patient Address</p>
                                    </label>
                                    {!!selectedItemsGIRP["patientSummary"] ? 
                                        <div className="child d-flex flex-column gap-2">
                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                <input
                                                type="radio"
                                                id={`address-false-${id}-GIRP`}
                                                name={`ShowPatientsData-${id}-GIRP`}
                                                value="false"
                                                checked={showAddressTypeLocationGIRP === 'false'}
                                                onChange={(e) => setShowAddressTypeLocationGIRP(e.target.value)}
                                                />
                                                <label className="text ar-orange-text text-nowrap" htmlFor={`address-false-${id}-GIRP`}>Patient Address</label>
                                            </div>
                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                <input
                                                type="radio"
                                                id={`address-true-${id}-GIRP`}
                                                name={`ShowPatientsData-${id}-GIRP`}
                                                value="true"
                                                checked={showAddressTypeLocationGIRP === 'true'}
                                                onChange={(e) => setShowAddressTypeLocationGIRP(e.target.value)} 
                                                />
                                                <label className="text ar-orange-text text-nowrap" htmlFor={`address-true-${id}-GIRP`}>Location Address</label>
                                            </div>
                                        </div> : <></>}
                                </div>
                                    
                                {/* "Custom Template Clinical" */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsGIRP["customTemplateClinical"]}
                                                onChange={() => toggleItem("customTemplateClinical")}
                                            />
                                        </div>
                                        <p className="text fs-13">Custom Template Clinical</p>
                                    </label>
                                </div>

                                {/* Subjective */}
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsGIRP["chiefComplaint"]}
                                                    onChange={() => toggleItem("chiefComplaint")}
                                                />
                                            </div>
                                            <p className="text fs-13">Chief Complaint</p>
                                        </label>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsGIRP["historyofPresentIllness"]}
                                                    onChange={() => toggleItem("historyofPresentIllness")}
                                                />
                                            </div>
                                            <p className="text fs-13">History of Present Illness</p>
                                        </label>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsGIRP["reviewOfSystem"]}
                                                    onChange={() => toggleItem("reviewOfSystem")}
                                                />
                                            </div>
                                            <p className="text fs-13">Review Of System</p>
                                        </label>
                                </div>

                                {/* Problems */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsGIRP["problems"]}
                                                onChange={() => toggleItem("problems")}
                                            />
                                        </div>
                                        <p className="text fs-13">Problems</p>
                                    </label>
                                </div>
                                {/* Goals */}
                                <label className="d-flex align-items-center gap-6 user-select-none">
                                    <div className="custom_check_box d-flex">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItemsGIRP["goalsNotes"]}
                                            onChange={() => toggleItem("goalsNotes")}
                                        />
                                    </div>
                                    <p className="text fs-13">Goals</p>
                                </label>
                                {/* Intervention */}
                                <label className="d-flex align-items-center gap-6 user-select-none">
                                    <div className="custom_check_box d-flex">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItemsGIRP["interventionNotes"]}
                                            onChange={() => toggleItem("interventionNotes")}
                                        />
                                    </div>
                                    <p className="text fs-13">Intervention</p>
                                </label>
                                {/* Response */}
                                <label className="d-flex align-items-center gap-6 user-select-none">
                                    <div className="custom_check_box d-flex">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItemsGIRP["responseNotes"]}
                                            onChange={() => toggleItem("responseNotes")}
                                        />
                                    </div>
                                    <p className="text fs-13">Response</p>
                                </label>
                            </div>
                            {/* Right Column */}
                            <div className="d-flex flex-column row-gap-12">
                                {/* Plan */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsGIRP["plan"]}
                                                onChange={() => toggleItem("plan")}
                                            />
                                        </div>
                                        <p className="text fs-13">Plan</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsGIRP["prescriptions"]}
                                                    onChange={() => toggleItem("prescriptions")}
                                                />
                                            </div>
                                            <p className="text fs-13">Prescriptions</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsGIRP["supplements"]}
                                                    onChange={() => toggleItem("supplements")}
                                                />
                                            </div>
                                            <p className="text fs-13">Supplements</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsGIRP["vaccines"]}
                                                    onChange={() => toggleItem("vaccines")}
                                                />
                                            </div>
                                            <p className="text fs-13">Vaccines</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsGIRP["injections"]}
                                                    onChange={() => toggleItem("injections")}
                                                />
                                            </div>
                                            <p className="text fs-13">Injections</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsGIRP["labs"]}
                                                    onChange={() => toggleItem("labs")}
                                                />
                                            </div>
                                            <p className="text fs-13">Labs</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsGIRP["imaging"]}
                                                    onChange={() => toggleItem("imaging")}
                                                />
                                            </div>
                                            <p className="text fs-13">Imaging</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsGIRP["planNotes"]}
                                                    onChange={() => toggleItem("planNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsGIRP["followUp"]}
                                                    onChange={() => toggleItem("followUp")}
                                                />
                                            </div>
                                            <p className="text fs-13">Follow-Up</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Additional Info */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsGIRP["additionalInfo"]}
                                                onChange={() => toggleItem("additionalInfo")}
                                            />
                                        </div>
                                        <p className="text fs-13">Additional Info</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsGIRP["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                            </div>
                                            <p className="text fs-13">Documents</p>
                                        </label>
                                         <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsGIRP["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Procedure Codes */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsGIRP["procedureCodes"]}
                                                onChange={() => toggleItem("procedureCodes")}
                                            />
                                        </div>
                                        <p className="text fs-13">Procedure Codes</p>
                                    </label>
                                </div>
                            </div>
                        </div>}
                        </div> : <></>}

                        {noteTypeSet.has('BIRP') ? 
                        <div>
                            <div className="d-flex justify-content-between align-items-center br-bottom-1 za_br_light pb-1-5">
                                <div className="d-flex align-items-center gap-6 cursor-pointer" onClick={() => handleAccord("BIRP")}>
                                    <i className={`${activeAccord === "BIRP" ? 'icon-up' : 'icon-down'} fs-10`}></i>
                                    <p className="heading user-select-none">BIRP Note</p>
                                </div>
                                <p
                                    className="heading validate-color cursor-pointer user-select-none"
                                    onClick={() => selectAll('BIRP')}
                                >
                                    Select All
                                </p>
                            </div> 
                        {activeAccord === "BIRP" &&
                        <div className="d-flex gap-15 justify-content-between mt-2">
                            <div className="d-flex flex-column row-gap-12">
                                {/* Patient Summary */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsBIRP["patientSummary"]}
                                                onChange={() => toggleItem("patientSummary")}
                                            />
                                        </div>
                                        <p className="text fs-13">Patient Address</p>
                                    </label>
                                    {!!selectedItemsBIRP["patientSummary"] ? 
                                        <div className="child d-flex flex-column gap-2">
                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                <input
                                                type="radio"
                                                id={`address-false-${id}-BIRP`}
                                                name={`ShowPatientsData-${id}-BIRP`}
                                                value="false"
                                                checked={showAddressTypeLocationBIRP === 'false'}
                                                onChange={(e) => setShowAddressTypeLocationBIRP(e.target.value)}
                                                />
                                                <label className="text ar-orange-text text-nowrap" htmlFor={`address-false-${id}-BIRP`}>Patient Address</label>
                                            </div>
                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                <input
                                                type="radio"
                                                id={`address-true-${id}-BIRP`}
                                                name={`ShowPatientsData-${id}-BIRP`}
                                                value="true"
                                                checked={showAddressTypeLocationBIRP === 'true'}
                                                onChange={(e) => setShowAddressTypeLocationBIRP(e.target.value)} 
                                                />
                                                <label className="text ar-orange-text text-nowrap" htmlFor={`address-true-${id}-BIRP`}>Location Address</label>
                                            </div>
                                        </div> : <></>}
                                </div>
                                    
                                {/* "Custom Template Clinical" */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsBIRP["customTemplateClinical"]}
                                                onChange={() => toggleItem("customTemplateClinical")}
                                            />
                                        </div>
                                        <p className="text fs-13">Custom Template Clinical</p>
                                    </label>
                                </div>

                                {/* Subjective */}
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsBIRP["chiefComplaint"]}
                                                    onChange={() => toggleItem("chiefComplaint")}
                                                />
                                            </div>
                                            <p className="text fs-13">Chief Complaint</p>
                                        </label>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsBIRP["historyofPresentIllness"]}
                                                    onChange={() => toggleItem("historyofPresentIllness")}
                                                />
                                            </div>
                                            <p className="text fs-13">History of Present Illness</p>
                                        </label>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsBIRP["reviewOfSystem"]}
                                                    onChange={() => toggleItem("reviewOfSystem")}
                                                />
                                            </div>
                                            <p className="text fs-13">Review Of System</p>
                                        </label>
                                </div>

                                {/* Problems */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsBIRP["problems"]}
                                                onChange={() => toggleItem("problems")}
                                            />
                                        </div>
                                        <p className="text fs-13">Problems</p>
                                    </label>
                                </div>
                                {/* Behaviour */}
                                <label className="d-flex align-items-center gap-6 user-select-none">
                                    <div className="custom_check_box d-flex">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItemsBIRP["behaviourNotes"]}
                                            onChange={() => toggleItem("behaviourNotes")}
                                        />
                                    </div>
                                    <p className="text fs-13">Behaviour</p>
                                </label>
                                {/* Intervention */}
                                <label className="d-flex align-items-center gap-6 user-select-none">
                                    <div className="custom_check_box d-flex">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItemsBIRP["interventionNotes"]}
                                            onChange={() => toggleItem("interventionNotes")}
                                        />
                                    </div>
                                    <p className="text fs-13">Intervention</p>
                                </label>
                                {/* Response */}
                                <label className="d-flex align-items-center gap-6 user-select-none">
                                    <div className="custom_check_box d-flex">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItemsBIRP["responseNotes"]}
                                            onChange={() => toggleItem("responseNotes")}
                                        />
                                    </div>
                                    <p className="text fs-13">Response</p>
                                </label>
                            </div>
                            {/* Right Column */}
                            <div className="d-flex flex-column row-gap-12">
                                {/* Plan */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsBIRP["plan"]}
                                                onChange={() => toggleItem("plan")}
                                            />
                                        </div>
                                        <p className="text fs-13">Plan</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsBIRP["prescriptions"]}
                                                    onChange={() => toggleItem("prescriptions")}
                                                />
                                            </div>
                                            <p className="text fs-13">Prescriptions</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsBIRP["supplements"]}
                                                    onChange={() => toggleItem("supplements")}
                                                />
                                            </div>
                                            <p className="text fs-13">Supplements</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsBIRP["vaccines"]}
                                                    onChange={() => toggleItem("vaccines")}
                                                />
                                            </div>
                                            <p className="text fs-13">Vaccines</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsBIRP["injections"]}
                                                    onChange={() => toggleItem("injections")}
                                                />
                                            </div>
                                            <p className="text fs-13">Injections</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsBIRP["labs"]}
                                                    onChange={() => toggleItem("labs")}
                                                />
                                            </div>
                                            <p className="text fs-13">Labs</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsBIRP["imaging"]}
                                                    onChange={() => toggleItem("imaging")}
                                                />
                                            </div>
                                            <p className="text fs-13">Imaging</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsBIRP["planNotes"]}
                                                    onChange={() => toggleItem("planNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsBIRP["followUp"]}
                                                    onChange={() => toggleItem("followUp")}
                                                />
                                            </div>
                                            <p className="text fs-13">Follow-Up</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Additional Info */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsBIRP["additionalInfo"]}
                                                onChange={() => toggleItem("additionalInfo")}
                                            />
                                        </div>
                                        <p className="text fs-13">Additional Info</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsBIRP["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                            </div>
                                            <p className="text fs-13">Documents</p>
                                        </label>
                                         <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsBIRP["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Procedure Codes */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsBIRP["procedureCodes"]}
                                                onChange={() => toggleItem("procedureCodes")}
                                            />
                                        </div>
                                        <p className="text fs-13">Procedure Codes</p>
                                    </label>
                                </div>
                            </div>
                        </div>}
                        </div> : <></>}
                        {noteTypeSet.has('DAP') ? 
                        <div>
                            <div className="d-flex justify-content-between align-items-center br-bottom-1 za_br_light pb-1-5">
                                <div className="d-flex align-items-center gap-6 cursor-pointer" onClick={() => handleAccord("DAP")}>
                                    <i className={`${activeAccord === "DAP" ? 'icon-up' : 'icon-down'} fs-10`}></i>
                                    <p className="heading user-select-none">DAP Note</p>
                                </div>
                                <p
                                    className="heading validate-color cursor-pointer user-select-none"
                                    onClick={() => selectAll('DAP')}
                                >
                                    Select All
                                </p>
                            </div> 
                        {activeAccord === "DAP" &&
                        <div className="d-flex gap-15 justify-content-between mt-2">
                            <div className="d-flex flex-column row-gap-12">
                                {/* Patient Summary */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsDAP["patientSummary"]}
                                                onChange={() => toggleItem("patientSummary")}
                                            />
                                        </div>
                                        <p className="text fs-13">Patient Address</p>
                                    </label>
                                    {!!selectedItemsDAP["patientSummary"] ? 
                                        <div className="child d-flex flex-column gap-2">
                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                <input
                                                type="radio"
                                                id={`address-false-${id}-DAP`}
                                                name={`ShowPatientsData-${id}-DAP`}
                                                value="false"
                                                checked={showAddressTypeLocationDAP === 'false'}
                                                onChange={(e) => setShowAddressTypeLocationDAP(e.target.value)}
                                                />
                                                <label className="text ar-orange-text text-nowrap" htmlFor={`address-false-${id}-DAP`}>Patient Address</label>
                                            </div>
                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                <input
                                                type="radio"
                                                id={`address-true-${id}-DAP`}
                                                name={`ShowPatientsData-${id}-DAP`}
                                                value="true"
                                                checked={showAddressTypeLocationDAP === 'true'}
                                                onChange={(e) => setShowAddressTypeLocationDAP(e.target.value)} 
                                                />
                                                <label className="text ar-orange-text text-nowrap" htmlFor={`address-true-${id}-DAP`}>Location Address</label>
                                            </div>
                                        </div> : <></>}
                                </div>
                                    
                                {/* "Custom Template Clinical" */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsDAP["customTemplateClinical"]}
                                                onChange={() => toggleItem("customTemplateClinical")}
                                            />
                                        </div>
                                        <p className="text fs-13">Custom Template Clinical</p>
                                    </label>
                                </div>

                                {/* Subjective */}
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAP["chiefComplaint"]}
                                                    onChange={() => toggleItem("chiefComplaint")}
                                                />
                                            </div>
                                            <p className="text fs-13">Chief Complaint</p>
                                        </label>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAP["historyofPresentIllness"]}
                                                    onChange={() => toggleItem("historyofPresentIllness")}
                                                />
                                            </div>
                                            <p className="text fs-13">History of Present Illness</p>
                                        </label>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAP["reviewOfSystem"]}
                                                    onChange={() => toggleItem("reviewOfSystem")}
                                                />
                                            </div>
                                            <p className="text fs-13">Review Of System</p>
                                        </label>
                                </div>

                                {/* Problems */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsDAP["problems"]}
                                                onChange={() => toggleItem("problems")}
                                            />
                                        </div>
                                        <p className="text fs-13">Problems</p>
                                    </label>
                                </div>
                                {/* Data */}
                                <label className="d-flex align-items-center gap-6 user-select-none">
                                    <div className="custom_check_box d-flex">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItemsDAP["dataNotes"]}
                                            onChange={() => toggleItem("dataNotes")}
                                        />
                                    </div>
                                    <p className="text fs-13">Data</p>
                                </label>
                                {/* Assessment */}
                                <label className="d-flex align-items-center gap-6 user-select-none">
                                    <div className="custom_check_box d-flex">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItemsDAP["assessmentNotes"]}
                                            onChange={() => toggleItem("assessmentNotes")}
                                        />
                                    </div>
                                    <p className="text fs-13">Assessment</p>
                                </label>
                            </div>
                            {/* Right Column */}
                            <div className="d-flex flex-column row-gap-12">
                                {/* Plan */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsDAP["plan"]}
                                                onChange={() => toggleItem("plan")}
                                            />
                                        </div>
                                        <p className="text fs-13">Plan</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAP["prescriptions"]}
                                                    onChange={() => toggleItem("prescriptions")}
                                                />
                                            </div>
                                            <p className="text fs-13">Prescriptions</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAP["supplements"]}
                                                    onChange={() => toggleItem("supplements")}
                                                />
                                            </div>
                                            <p className="text fs-13">Supplements</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAP["vaccines"]}
                                                    onChange={() => toggleItem("vaccines")}
                                                />
                                            </div>
                                            <p className="text fs-13">Vaccines</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAP["injections"]}
                                                    onChange={() => toggleItem("injections")}
                                                />
                                            </div>
                                            <p className="text fs-13">Injections</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAP["labs"]}
                                                    onChange={() => toggleItem("labs")}
                                                />
                                            </div>
                                            <p className="text fs-13">Labs</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAP["imaging"]}
                                                    onChange={() => toggleItem("imaging")}
                                                />
                                            </div>
                                            <p className="text fs-13">Imaging</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAP["planNotes"]}
                                                    onChange={() => toggleItem("planNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAP["followUp"]}
                                                    onChange={() => toggleItem("followUp")}
                                                />
                                            </div>
                                            <p className="text fs-13">Follow-Up</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Additional Info */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsDAP["additionalInfo"]}
                                                onChange={() => toggleItem("additionalInfo")}
                                            />
                                        </div>
                                        <p className="text fs-13">Additional Info</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAP["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                            </div>
                                            <p className="text fs-13">Documents</p>
                                        </label>
                                         <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAP["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Procedure Codes */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsDAP["procedureCodes"]}
                                                onChange={() => toggleItem("procedureCodes")}
                                            />
                                        </div>
                                        <p className="text fs-13">Procedure Codes</p>
                                    </label>
                                </div>
                            </div>
                        </div>}
                        </div> : <></>}
                        
                        {noteTypeSet.has('DAPP') ? 
                        <div>
                            <div className="d-flex justify-content-between align-items-center br-bottom-1 za_br_light pb-1-5">
                                <div className="d-flex align-items-center gap-6 cursor-pointer" onClick={() => handleAccord("DAPP")}>
                                    <i className={`${activeAccord === "DAPP" ? 'icon-up' : 'icon-down'} fs-10`}></i>
                                    <p className="heading user-select-none">DAPP Note</p>
                                </div>
                                <p
                                    className="heading validate-color cursor-pointer user-select-none"
                                    onClick={() => selectAll('DAPP')}
                                >
                                    Select All
                                </p>
                            </div> 
                        {activeAccord === "DAPP" &&
                        <div className="d-flex gap-15 justify-content-between mt-2">
                            <div className="d-flex flex-column row-gap-12">
                                {/* Patient Summary */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsDAPP["patientSummary"]}
                                                onChange={() => toggleItem("patientSummary")}
                                            />
                                        </div>
                                        <p className="text fs-13">Patient Address</p>
                                    </label>
                                    {!!selectedItemsDAPP["patientSummary"] ? 
                                        <div className="child d-flex flex-column gap-2">
                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                <input
                                                type="radio"
                                                id={`address-false-${id}-DAPP`}
                                                name={`ShowPatientsData-${id}-DAPP`}
                                                value="false"
                                                checked={showAddressTypeLocationDAPP === 'false'}
                                                onChange={(e) => setShowAddressTypeLocationDAPP(e.target.value)}
                                                />
                                                <label className="text ar-orange-text text-nowrap" htmlFor={`address-false-${id}-DAPP`}>Patient Address</label>
                                            </div>
                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                <input
                                                type="radio"
                                                id={`address-true-${id}-DAPP`}
                                                name={`ShowPatientsData-${id}-DAPP`}
                                                value="true"
                                                checked={showAddressTypeLocationDAPP === 'true'}
                                                onChange={(e) => setShowAddressTypeLocationDAPP(e.target.value)} 
                                                />
                                                <label className="text ar-orange-text text-nowrap" htmlFor={`address-true-${id}-DAPP`}>Location Address</label>
                                            </div>
                                        </div> : <></>}
                                </div>
                                    
                                {/* "Custom Template Clinical" */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsDAPP["customTemplateClinical"]}
                                                onChange={() => toggleItem("customTemplateClinical")}
                                            />
                                        </div>
                                        <p className="text fs-13">Custom Template Clinical</p>
                                    </label>
                                </div>

                                {/* Subjective */}
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAPP["chiefComplaint"]}
                                                    onChange={() => toggleItem("chiefComplaint")}
                                                />
                                            </div>
                                            <p className="text fs-13">Chief Complaint</p>
                                        </label>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAPP["historyofPresentIllness"]}
                                                    onChange={() => toggleItem("historyofPresentIllness")}
                                                />
                                            </div>
                                            <p className="text fs-13">History of Present Illness</p>
                                        </label>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAPP["reviewOfSystem"]}
                                                    onChange={() => toggleItem("reviewOfSystem")}
                                                />
                                            </div>
                                            <p className="text fs-13">Review Of System</p>
                                        </label>
                                </div>

                                {/* Problems */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsDAPP["problems"]}
                                                onChange={() => toggleItem("problems")}
                                            />
                                        </div>
                                        <p className="text fs-13">Problems</p>
                                    </label>
                                </div>
                                {/* Data */}
                                <label className="d-flex align-items-center gap-6 user-select-none">
                                    <div className="custom_check_box d-flex">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItemsDAPP["dataNotes"]}
                                            onChange={() => toggleItem("dataNotes")}
                                        />
                                    </div>
                                    <p className="text fs-13">Data</p>
                                </label>
                                {/* Assessment */}
                                <label className="d-flex align-items-center gap-6 user-select-none">
                                    <div className="custom_check_box d-flex">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItemsDAPP["assessmentNotes"]}
                                            onChange={() => toggleItem("assessmentNotes")}
                                        />
                                    </div>
                                    <p className="text fs-13">Assessment</p>
                                </label>
                                {/* Progress */}
                                <label className="d-flex align-items-center gap-6 user-select-none">
                                    <div className="custom_check_box d-flex">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItemsDAPP["progressNotes"]}
                                            onChange={() => toggleItem("progressNotes")}
                                        />
                                    </div>
                                    <p className="text fs-13">Progress</p>
                                </label>
                            </div>
                            {/* Right Column */}
                            <div className="d-flex flex-column row-gap-12">
                                {/* Plan */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsDAPP["plan"]}
                                                onChange={() => toggleItem("plan")}
                                            />
                                        </div>
                                        <p className="text fs-13">Plan</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAPP["prescriptions"]}
                                                    onChange={() => toggleItem("prescriptions")}
                                                />
                                            </div>
                                            <p className="text fs-13">Prescriptions</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAPP["supplements"]}
                                                    onChange={() => toggleItem("supplements")}
                                                />
                                            </div>
                                            <p className="text fs-13">Supplements</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAPP["vaccines"]}
                                                    onChange={() => toggleItem("vaccines")}
                                                />
                                            </div>
                                            <p className="text fs-13">Vaccines</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAPP["injections"]}
                                                    onChange={() => toggleItem("injections")}
                                                />
                                            </div>
                                            <p className="text fs-13">Injections</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAPP["labs"]}
                                                    onChange={() => toggleItem("labs")}
                                                />
                                            </div>
                                            <p className="text fs-13">Labs</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAPP["imaging"]}
                                                    onChange={() => toggleItem("imaging")}
                                                />
                                            </div>
                                            <p className="text fs-13">Imaging</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAPP["planNotes"]}
                                                    onChange={() => toggleItem("planNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAPP["followUp"]}
                                                    onChange={() => toggleItem("followUp")}
                                                />
                                            </div>
                                            <p className="text fs-13">Follow-Up</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Additional Info */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsDAPP["additionalInfo"]}
                                                onChange={() => toggleItem("additionalInfo")}
                                            />
                                        </div>
                                        <p className="text fs-13">Additional Info</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAPP["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                            </div>
                                            <p className="text fs-13">Documents</p>
                                        </label>
                                         <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsDAPP["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Procedure Codes */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsDAPP["procedureCodes"]}
                                                onChange={() => toggleItem("procedureCodes")}
                                            />
                                        </div>
                                        <p className="text fs-13">Procedure Codes</p>
                                    </label>
                                </div>
                            </div>
                        </div>}
                        </div> : <></>}

                        {noteTypeSet.has('Therapy') ? 
                        <div>
                            <div className="d-flex justify-content-between align-items-center br-bottom-1 za_br_light pb-1-5">
                                <div className="d-flex align-items-center gap-6 cursor-pointer" onClick={() => handleAccord("Therapy")}>
                                    <i className={`${activeAccord === "Therapy" ? 'icon-up' : 'icon-down'} fs-10`}></i>
                                    <p className="heading user-select-none">Therapy Note</p>
                                </div>
                                <p
                                    className="heading validate-color cursor-pointer user-select-none"
                                    onClick={() => selectAll('Therapy')}
                                >
                                    Select All
                                </p>
                            </div> 
                        {activeAccord === "Therapy" &&
                        <div className="d-flex gap-15 justify-content-between mt-2">
                            <div className="d-flex flex-column row-gap-12">
                                {/* Patient Summary */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsTherapy["patientSummary"]}
                                                onChange={() => toggleItem("patientSummary")}
                                            />
                                        </div>
                                        <p className="text fs-13">Patient Address</p>
                                    </label>
                                    {!!selectedItemsTherapy["patientSummary"] ? 
                                        <div className="child d-flex flex-column gap-2">
                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                <input
                                                type="radio"
                                                id={`address-false-${id}-Therapy`}
                                                name={`ShowPatientsData-${id}-Therapy`}
                                                value="false"
                                                checked={showAddressTypeLocationTherapy === 'false'}
                                                onChange={(e) => setShowAddressTypeLocationTherapy(e.target.value)}
                                                />
                                                <label className="text ar-orange-text text-nowrap" htmlFor={`address-false-${id}-Therapy`}>Patient Address</label>
                                            </div>
                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                <input
                                                type="radio"
                                                id={`address-true-${id}-Therapy`}
                                                name={`ShowPatientsData-${id}-Therapy`}
                                                value="true"
                                                checked={showAddressTypeLocationTherapy === 'true'}
                                                onChange={(e) => setShowAddressTypeLocationTherapy(e.target.value)} 
                                                />
                                                <label className="text ar-orange-text text-nowrap" htmlFor={`address-true-${id}-Therapy`}>Location Address</label>
                                            </div>
                                        </div> : <></>}
                                </div>
                                    
                                {/* "Custom Template Clinical" */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsTherapy["customTemplateClinical"]}
                                                onChange={() => toggleItem("customTemplateClinical")}
                                            />
                                        </div>
                                        <p className="text fs-13">Custom Template Clinical</p>
                                    </label>
                                </div>

                                {/* Subjective */}
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["chiefComplaint"]}
                                                    onChange={() => toggleItem("chiefComplaint")}
                                                />
                                            </div>
                                            <p className="text fs-13">Chief Complaint</p>
                                        </label>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["historyofPresentIllness"]}
                                                    onChange={() => toggleItem("historyofPresentIllness")}
                                                />
                                            </div>
                                            <p className="text fs-13">History of Present Illness</p>
                                        </label>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["reviewOfSystem"]}
                                                    onChange={() => toggleItem("reviewOfSystem")}
                                                />
                                            </div>
                                            <p className="text fs-13">Review Of System</p>
                                        </label>
                                </div>

                                {/* Problems */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsTherapy["problems"]}
                                                onChange={() => toggleItem("problems")}
                                            />
                                        </div>
                                        <p className="text fs-13">Problems</p>
                                    </label>
                                </div>

                                {/* Objective */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsTherapy["objective"]}
                                                onChange={() => toggleItem("objective")}
                                            />
                                        </div>
                                        <p className="text fs-13">Objective</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["currentMentalStatus"]}
                                                    onChange={() => toggleItem("currentMentalStatus")}
                                                />
                                            </div>
                                            <p className="text fs-13">Current Mental Status</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["objectiveNotes"]}
                                                    onChange={() => toggleItem("objectiveNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Intervention */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsTherapy["intervention"]}
                                                onChange={() => toggleItem("intervention")}
                                            />
                                        </div>
                                        <p className="text fs-13">Intervention</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["interventionNotes"]}
                                                    onChange={() => toggleItem("interventionNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["interventionsUsed"]}
                                                    onChange={() => toggleItem("interventionsUsed")}
                                                />
                                            </div>
                                            <p className="text fs-13">Interventions Used</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Response */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsTherapy["response"]}
                                                onChange={() => toggleItem("response")}
                                            />
                                        </div>
                                        <p className="text fs-13">Response</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["responseNotes"]}
                                                    onChange={() => toggleItem("responseNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["responseObservations"]}
                                                    onChange={() => toggleItem("responseObservations")}
                                                />
                                            </div>
                                            <p className="text fs-13">Response Observations</p>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            {/* Right Column */}
                            <div className="d-flex flex-column row-gap-12">
                                {/* Assessment */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsTherapy["assessment"]}
                                                onChange={() => toggleItem("assessment")}
                                            />
                                        </div>
                                        <p className="text fs-13">Assessment</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["riskAssessment"]}
                                                    onChange={() => toggleItem("riskAssessment")}
                                                />
                                            </div>
                                            <p className="text fs-13">Risk Assessment</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["assessmentNotes"]}
                                                    onChange={() => toggleItem("assessmentNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                </div>
                                {/* Plan */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsTherapy["plan"]}
                                                onChange={() => toggleItem("plan")}
                                            />
                                        </div>
                                        <p className="text fs-13">Plan</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["prescriptions"]}
                                                    onChange={() => toggleItem("prescriptions")}
                                                />
                                            </div>
                                            <p className="text fs-13">Prescriptions</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["supplements"]}
                                                    onChange={() => toggleItem("supplements")}
                                                />
                                            </div>
                                            <p className="text fs-13">Supplements</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["vaccines"]}
                                                    onChange={() => toggleItem("vaccines")}
                                                />
                                            </div>
                                            <p className="text fs-13">Vaccines</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["injections"]}
                                                    onChange={() => toggleItem("injections")}
                                                />
                                            </div>
                                            <p className="text fs-13">Injections</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["labs"]}
                                                    onChange={() => toggleItem("labs")}
                                                />
                                            </div>
                                            <p className="text fs-13">Labs</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["imaging"]}
                                                    onChange={() => toggleItem("imaging")}
                                                />
                                            </div>
                                            <p className="text fs-13">Imaging</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["planNotes"]}
                                                    onChange={() => toggleItem("planNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["followUp"]}
                                                    onChange={() => toggleItem("followUp")}
                                                />
                                            </div>
                                            <p className="text fs-13">Follow-Up</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Additional Info */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsTherapy["additionalInfo"]}
                                                onChange={() => toggleItem("additionalInfo")}
                                            />
                                        </div>
                                        <p className="text fs-13">Additional Info</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                            </div>
                                            <p className="text fs-13">Documents</p>
                                        </label>
                                         <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsTherapy["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Procedure Codes */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsTherapy["procedureCodes"]}
                                                onChange={() => toggleItem("procedureCodes")}
                                            />
                                        </div>
                                        <p className="text fs-13">Procedure Codes</p>
                                    </label>
                                </div>
                            </div>
                        </div>}
                        </div> : <></>}

                        {noteTypeSet.has('Massage') ? 
                        <div>
                            <div className="d-flex justify-content-between align-items-center br-bottom-1 za_br_light pb-1-5">
                                <div className="d-flex align-items-center gap-6 cursor-pointer" onClick={() => handleAccord("Massage")}>
                                    <i className={`${activeAccord === "Massage" ? 'icon-up' : 'icon-down'} fs-10`}></i>
                                    <p className="heading user-select-none">Massage Note</p>
                                </div>
                                <p
                                    className="heading validate-color cursor-pointer user-select-none"
                                    onClick={() => selectAll('Massage')}
                                >
                                    Select All
                                </p>
                            </div> 
                        {activeAccord === "Massage" &&
                        <div className="d-flex gap-15 justify-content-between mt-2">
                            <div className="d-flex flex-column row-gap-12">
                                {/* Patient Summary */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsMassage["patientSummary"]}
                                                onChange={() => toggleItem("patientSummary")}
                                            />
                                        </div>
                                        <p className="text fs-13">Patient Address</p>
                                    </label>
                                    {!!selectedItemsMassage["patientSummary"] ? 
                                        <div className="child d-flex flex-column gap-2">
                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                <input
                                                type="radio"
                                                id={`address-false-${id}-Massage`}
                                                name={`ShowPatientsData-${id}-Massage`}
                                                value="false"
                                                checked={showAddressTypeLocationMassage === 'false'}
                                                onChange={(e) => setShowAddressTypeLocationMassage(e.target.value)}
                                                />
                                                <label className="text ar-orange-text text-nowrap" htmlFor={`address-false-${id}-Massage`}>Patient Address</label>
                                            </div>
                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                <input
                                                type="radio"
                                                id={`address-true-${id}-Massage`}
                                                name={`ShowPatientsData-${id}-Massage`}
                                                value="true"
                                                checked={showAddressTypeLocationMassage === 'true'}
                                                onChange={(e) => setShowAddressTypeLocationMassage(e.target.value)} 
                                                />
                                                <label className="text ar-orange-text text-nowrap" htmlFor={`address-true-${id}-Massage`}>Location Address</label>
                                            </div>
                                        </div> : <></>}
                                </div>
                                    
                                {/* "Custom Template Clinical" */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsMassage["customTemplateClinical"]}
                                                onChange={() => toggleItem("customTemplateClinical")}
                                            />
                                        </div>
                                        <p className="text fs-13">Custom Template Clinical</p>
                                    </label>
                                </div>

                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsMassage["chiefComplaint"]}
                                                    onChange={() => toggleItem("chiefComplaint")}
                                                />
                                            </div>
                                            <p className="text fs-13">Chief Complaint</p>
                                        </label>
                                </div>
                                {/* <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsMassage["historyofPresentIllness"]}
                                                    onChange={() => toggleItem("historyofPresentIllness")}
                                                />
                                            </div>
                                            <p className="text fs-13">History of Present Illness</p>
                                        </label>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsMassage["reviewOfSystem"]}
                                                    onChange={() => toggleItem("reviewOfSystem")}
                                                />
                                            </div>
                                            <p className="text fs-13">Review Of System</p>
                                        </label>
                                </div> */}

                                {/* Problems */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsMassage["problems"]}
                                                onChange={() => toggleItem("problems")}
                                            />
                                        </div>
                                        <p className="text fs-13">Problems</p>
                                    </label>
                                </div>

                                {/* Subjective */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsMassage["subjectiveNotes"]}
                                                onChange={() => toggleItem("subjectiveNotes")}
                                            />
                                        </div>
                                        <p className="text fs-13">Subjective</p>
                                    </label>
                                </div>

                                {/* Objective */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsMassage["objective"]}
                                                onChange={() => toggleItem("objective")}
                                            />
                                        </div>
                                        <p className="text fs-13">Objective</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsMassage["objectiveFindings"]}
                                                    onChange={() => toggleItem("objectiveFindings")}
                                                />
                                            </div>
                                            <p className="text fs-13">Objective Findings</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsMassage["objectiveNotes"]}
                                                    onChange={() => toggleItem("objectiveNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                        {/* <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsMassage["currentMentalStatus"]}
                                                    onChange={() => toggleItem("currentMentalStatus")}
                                                />
                                            </div>
                                            <p className="text fs-13">Current Mental Status</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsMassage["objectiveNotes"]}
                                                    onChange={() => toggleItem("objectiveNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label> */}
                                    </div>
                                </div>

                                {/* Assessment */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsMassage["assessment"]}
                                                onChange={() => toggleItem("assessment")}
                                            />
                                        </div>
                                        <p className="text fs-13">Assessment</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsMassage["assessmentAreaTreated"]}
                                                    onChange={() => toggleItem("assessmentAreaTreated")}
                                                />
                                            </div>
                                            <p className="text fs-13">Areas Treated</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsMassage["focusArea"]}
                                                    onChange={() => toggleItem("focusArea")}
                                                />
                                            </div>
                                            <p className="text fs-13">Focus Area</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsMassage["assessmentMethodUsed"]}
                                                    onChange={() => toggleItem("assessmentMethodUsed")}
                                                />
                                            </div>
                                            <p className="text fs-13">Methods Used</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsMassage["assessmentNotes"]}
                                                    onChange={() => toggleItem("assessmentNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            {/* Right Column */}
                            <div className="d-flex flex-column row-gap-12">
                                {/* Plan */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsMassage["plan"]}
                                                onChange={() => toggleItem("plan")}
                                            />
                                        </div>
                                        <p className="text fs-13">Plan</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsMassage["planNotes"]}
                                                    onChange={() => toggleItem("planNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsMassage["homeExerciseProgram"]}
                                                    onChange={() => toggleItem("homeExerciseProgram")}
                                                />
                                            </div>
                                            <p className="text fs-13">Home Exercise Program(HEP)</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsMassage["followUp"]}
                                                    onChange={() => toggleItem("followUp")}
                                                />
                                            </div>
                                            <p className="text fs-13">Follow Up</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Additional Info */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsMassage["additionalInfo"]}
                                                onChange={() => toggleItem("additionalInfo")}
                                            />
                                        </div>
                                        <p className="text fs-13">Additional Info</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsMassage["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                            </div>
                                            <p className="text fs-13">Documents</p>
                                        </label>
                                         <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsMassage["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Procedure Codes */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsMassage["procedureCodes"]}
                                                onChange={() => toggleItem("procedureCodes")}
                                            />
                                        </div>
                                        <p className="text fs-13">Procedure Codes</p>
                                    </label>
                                </div>
                            </div>
                        </div>}
                        </div> : <></>}

                        {noteTypeSet.has('Physical') ? 
                        <div>
                            <div className="d-flex justify-content-between align-items-center br-bottom-1 za_br_light pb-1-5">
                                <div className="d-flex align-items-center gap-6 cursor-pointer" onClick={() => handleAccord("Physical")}>
                                    <i className={`${activeAccord === "Physical" ? 'icon-up' : 'icon-down'} fs-10`}></i>
                                    <p className="heading user-select-none">Physical Note</p>
                                </div>
                                <p
                                    className="heading validate-color cursor-pointer user-select-none"
                                    onClick={() => selectAll('Physical')}
                                >
                                    Select All
                                </p>
                            </div> 
                        {activeAccord === "Physical" &&
                        <div className="d-flex gap-15 justify-content-between mt-2">
                            <div className="d-flex flex-column row-gap-12">
                                {/* Patient Summary */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsPhysical["patientSummary"]}
                                                onChange={() => toggleItem("patientSummary")}
                                            />
                                        </div>
                                        <p className="text fs-13">Patient Address</p>
                                    </label>
                                    {!!selectedItemsPhysical["patientSummary"] ? 
                                        <div className="child d-flex flex-column gap-2">
                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                <input
                                                type="radio"
                                                id={`address-false-${id}-Physical`}
                                                name={`ShowPatientsData-${id}-Physical`}
                                                value="false"
                                                checked={showAddressTypeLocationPhysical === 'false'}
                                                onChange={(e) => setShowAddressTypeLocationPhysical(e.target.value)}
                                                />
                                                <label className="text ar-orange-text text-nowrap" htmlFor={`address-false-${id}-Physical`}>Patient Address</label>
                                            </div>
                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                <input
                                                type="radio"
                                                id={`address-true-${id}-Physical`}
                                                name={`ShowPatientsData-${id}-Physical`}
                                                value="true"
                                                checked={showAddressTypeLocationPhysical === 'true'}
                                                onChange={(e) => setShowAddressTypeLocationPhysical(e.target.value)} 
                                                />
                                                <label className="text ar-orange-text text-nowrap" htmlFor={`address-true-${id}-Physical`}>Location Address</label>
                                            </div>
                                        </div> : <></>}
                                </div>
                                    
                                {/* "Custom Template Clinical" */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsPhysical["customTemplateClinical"]}
                                                onChange={() => toggleItem("customTemplateClinical")}
                                            />
                                        </div>
                                        <p className="text fs-13">Custom Template Clinical</p>
                                    </label>
                                </div>

                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsPhysical["chiefComplaint"]}
                                                    onChange={() => toggleItem("chiefComplaint")}
                                                />
                                            </div>
                                            <p className="text fs-13">Chief Complaint</p>
                                        </label>
                                </div>

                                {/* Problems */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsPhysical["problems"]}
                                                onChange={() => toggleItem("problems")}
                                            />
                                        </div>
                                        <p className="text fs-13">Problems</p>
                                    </label>
                                </div>

                                {/* Subjective */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsPhysical["subjectiveNotes"]}
                                                onChange={() => toggleItem("subjectiveNotes")}
                                            />
                                        </div>
                                        <p className="text fs-13">Subjective</p>
                                    </label>
                                </div>

                                {/* Objective */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsPhysical["objective"]}
                                                onChange={() => toggleItem("objective")}
                                            />
                                        </div>
                                        <p className="text fs-13">Objective</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsPhysical["observationNotes"]}
                                                    onChange={() => toggleItem("observationNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Observations</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsPhysical["problemArea"]}
                                                    onChange={() => toggleItem("problemArea")}
                                                />
                                            </div>
                                            <p className="text fs-13">Problem Area</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsPhysical["palpationNotes"]}
                                                    onChange={() => toggleItem("palpationNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Palpation</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsPhysical["rangeOfMotion"]}
                                                    onChange={() => toggleItem("rangeOfMotion")}
                                                />
                                            </div>
                                            <p className="text fs-13">Range of Motion</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsPhysical["strength"]}
                                                    onChange={() => toggleItem("strength")}
                                                />
                                            </div>
                                            <p className="text fs-13">Strength</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsPhysical["testMeasurementNotes"]}
                                                    onChange={() => toggleItem("testMeasurementNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Tests & Measurements</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsPhysical["objectiveNotes"]}
                                                    onChange={() => toggleItem("objectiveNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Assessment */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsPhysical["assessment"]}
                                                onChange={() => toggleItem("assessment")}
                                            />
                                        </div>
                                        <p className="text fs-13">Assessment</p>
                                    </label>
                                </div>
                            </div>
                            {/* Right Column */}
                            <div className="d-flex flex-column row-gap-12">
                                {/* Plan */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsPhysical["plan"]}
                                                onChange={() => toggleItem("plan")}
                                            />
                                        </div>
                                        <p className="text fs-13">Plan</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsPhysical["planNotes"]}
                                                    onChange={() => toggleItem("planNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsPhysical["homeExerciseProgram"]}
                                                    onChange={() => toggleItem("homeExerciseProgram")}
                                                />
                                            </div>
                                            <p className="text fs-13">Home Exercise Program(HEP)</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsPhysical["followUp"]}
                                                    onChange={() => toggleItem("followUp")}
                                                />
                                            </div>
                                            <p className="text fs-13">Follow Up</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Additional Info */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsPhysical["additionalInfo"]}
                                                onChange={() => toggleItem("additionalInfo")}
                                            />
                                        </div>
                                        <p className="text fs-13">Additional Info</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsPhysical["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                            </div>
                                            <p className="text fs-13">Documents</p>
                                        </label>
                                         <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsPhysical["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Procedure Codes */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsPhysical["procedureCodes"]}
                                                onChange={() => toggleItem("procedureCodes")}
                                            />
                                        </div>
                                        <p className="text fs-13">Procedure Codes</p>
                                    </label>
                                </div>
                            </div>
                        </div>}
                        </div> : <></>}

                        {noteTypeSet.has('Other') ?
                        <div>
                            <div className="d-flex justify-content-between align-items-center br-bottom-1 za_br_light pb-1-5">
                                <div className="d-flex align-items-center gap-6 cursor-pointer" onClick={() => handleAccord("Other")}>
                                    <i className={`${activeAccord === "Other" ? 'icon-up' : 'icon-down'} fs-10`}></i>
                                    <p className="heading user-select-none">Other Note</p>
                                </div>
                                <p
                                    className="heading validate-color cursor-pointer user-select-none"
                                    onClick={() => selectAll('Other')}
                                >
                                    Select All
                                </p>
                            </div>
                        {activeAccord === "Other" &&
                        <div className="d-flex gap-15 justify-content-between mt-2">
                            <div className="d-flex flex-column row-gap-12">
                                {/* Patient Summary */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsOther["patientSummary"]}
                                                onChange={() => toggleItem("patientSummary")}
                                            />
                                        </div>
                                        <p className="text fs-13">Patient Address</p>
                                    </label>
                                    {!!selectedItemsOther["patientSummary"] ? 
                                        <div className="child d-flex flex-column gap-2">
                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                <input
                                                type="radio"
                                                id={`address-false-${id}-Other`}
                                                name={`ShowPatientsData-${id}-Other`}
                                                value="false"
                                                checked={showAddressTypeLocationOther === 'false'}
                                                onChange={(e) => setShowAddressTypeLocationOther(e.target.value)}
                                                />
                                                <label className="text ar-orange-text text-nowrap" htmlFor={`address-false-${id}-Other`}>Patient Address</label>
                                            </div>
                                            <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                <input
                                                type="radio"
                                                id={`address-true-${id}-Other`}
                                                name={`ShowPatientsData-${id}-Other`}
                                                value="true"
                                                checked={showAddressTypeLocationOther === 'true'}
                                                onChange={(e) => setShowAddressTypeLocationOther(e.target.value)} 
                                                />
                                                <label className="text ar-orange-text text-nowrap" htmlFor={`address-true-${id}-Other`}>Location Address</label>
                                            </div>
                                        </div> : <></>}
                                </div>
                                    
                                {/* "Custom Template Clinical" */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsOther["customTemplateClinical"]}
                                                onChange={() => toggleItem("customTemplateClinical")}
                                            />
                                        </div>
                                        <p className="text fs-13">Custom Template Clinical</p>
                                    </label>
                                </div>

                                {/* Subjective */}
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsOther["chiefComplaint"]}
                                                    onChange={() => toggleItem("chiefComplaint")}
                                                />
                                            </div>
                                            <p className="text fs-13">Chief Complaint</p>
                                        </label>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsOther["historyofPresentIllness"]}
                                                    onChange={() => toggleItem("historyofPresentIllness")}
                                                />
                                            </div>
                                            <p className="text fs-13">History of Present Illness</p>
                                        </label>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsOther["reviewOfSystem"]}
                                                    onChange={() => toggleItem("reviewOfSystem")}
                                                />
                                            </div>
                                            <p className="text fs-13">Review Of System</p>
                                        </label>
                                </div>

                                {/* Objective */}
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsOther["vitals"]}
                                                    onChange={() => toggleItem("vitals")}
                                                />
                                            </div>
                                            <p className="text fs-13">Vitals</p>
                                        </label>
                                </div>

                                {/* Assessment */}
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsOther["problems"]}
                                                    onChange={() => toggleItem("problems")}
                                                />
                                            </div>
                                            <p className="text fs-13">Problems</p>
                                        </label>
                                </div>
                            </div>
                            {/* Right Column */}
                            <div className="d-flex flex-column row-gap-12">
                                {/* Plan */}
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsOther["otherNote"]}
                                                    onChange={() => toggleItem("otherNote")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    {/* </div> */}
                                </div>
                                
                                {/* Follow Up */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsOther["followUp"]}
                                                onChange={() => toggleItem("followUp")}
                                            />
                                        </div>
                                        <p className="text fs-13">Follow-Up</p>
                                    </label>
                                </div>

                                {/* Additional Info */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsOther["additionalInfo"]}
                                                onChange={() => toggleItem("additionalInfo")}
                                            />
                                        </div>
                                        <p className="text fs-13">Additional Info</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsOther["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                            </div>
                                            <p className="text fs-13">Documents</p>
                                        </label>
                                         <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItemsOther["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Procedure Codes */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItemsOther["procedureCodes"]}
                                                onChange={() => toggleItem("procedureCodes")}
                                            />
                                        </div>
                                        <p className="text fs-13">Procedure Codes</p>
                                    </label>
                                </div>
                            </div>
                        </div>}
                        </div> : <></>}
                        {filteredRemainingCustomNotes?.length > 0 ?
                        filteredRemainingCustomNotes?.map((customNote) => {
                            // console.log("selectedItems ", customNote, selectedItemsCustomNote, selectedItemsCustomNote?.[customNote])
                            // console.log("selectedItems Location", customNote, showAddressTypeLocationCustomNote, showAddressTypeLocationCustomNote?.[customNote])
                            let selectedItems = selectedItemsCustomNote?.[customNote];
                            let showAddressTypeLocation = showAddressTypeLocationCustomNote?.[customNote];
                            
                            return (
                            <>
                                {
                                // noteTypeSet.has('CustomNote') ?
                                <div>
                                    <div className="d-flex justify-content-between align-items-center br-bottom-1 za_br_light pb-1-5">
                                        <div className="d-flex align-items-center gap-6 cursor-pointer" onClick={() => handleAccord(customNote)}>
                                            <i className={`${activeAccord === customNote ? 'icon-up' : 'icon-down'} fs-10`}></i>
                                            <p className="heading user-select-none">{customNote}</p>
                                        </div>
                                        <p
                                            className="heading validate-color cursor-pointer user-select-none"
                                            onClick={() => selectAll(customNote)}
                                        >
                                            Select All
                                        </p>
                                    </div>
                                {activeAccord === customNote &&
                                <div className="d-flex gap-15 justify-content-between mt-2">
                                    <div className="d-flex flex-column row-gap-12">
                                        {/* Patient Summary */}
                                        <div className="d-flex flex-column gap-2">
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItems["patientSummary"]}
                                                        onChange={() => toggleItem("patientSummary")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Patient Address</p>
                                            </label>
                                            {!!selectedItems["patientSummary"] ? 
                                                <div className="child d-flex flex-column gap-2">
                                                    <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                        <input
                                                        type="radio"
                                                        id={`address-false-${id}-${customNote}`}
                                                        name={`ShowPatientsData-${id}-${customNote}`}
                                                        value="false"
                                                        checked={showAddressTypeLocation === 'false'}
                                                        onChange={(e) => setShowAddressTypeLocationCustomNote(prev => ({ ...prev, [customNote]: e.target.value}))}
                                                        />
                                                        <label className="text ar-orange-text text-nowrap" htmlFor={`address-false-${id}-${customNote}`}>Patient Address</label>
                                                    </div>
                                                    <div className="ar_radio-btn d-flex align-items-center gap-6">
                                                        <input
                                                        type="radio"
                                                        id={`address-true-${id}-${customNote}`}
                                                        name={`ShowPatientsData-${id}-${customNote}`}
                                                        value="true"
                                                        checked={showAddressTypeLocation === 'true'}
                                                        onChange={(e) => setShowAddressTypeLocationCustomNote(prev => ({ ...prev, [customNote]: e.target.value}))} 
                                                        />
                                                        <label className="text ar-orange-text text-nowrap" htmlFor={`address-true-${id}-${customNote}`}>Location Address</label>
                                                    </div>
                                                </div> : <></>}
                                        </div>
                                            
                                        {/* "Custom Template Clinical" */}
                                        <div>
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItems["customTemplateClinical"]}
                                                        onChange={() => toggleItem("customTemplateClinical")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Custom Template Clinical</p>
                                            </label>
                                        </div>

                                        {/* Custom Note */}
                                        <div className="d-flex flex-column gap-2">
                                                <label className="d-flex align-items-center gap-6 user-select-none">
                                                    <div className="custom_check_box d-flex">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input m-0 p-0"
                                                            checked={!!selectedItems["mainCustomTemplateClinical"]}
                                                            onChange={() => toggleItem("mainCustomTemplateClinical")}
                                                        />
                                                    </div>
                                                    <p className="text fs-13">{props?.customTemplateData?.[0]?.TemplateName || "Main Custom Template Clinical"}</p>
                                                    {/* <p className="text fs-13">{props?.customTemplateData?.[0]?.TemplateName || "Main Custom Template Clinical"}</p> */}
                                                </label>
                                        </div>
                                        {/* Subjective */}
                                        {/* <div className="d-flex flex-column gap-2">
                                                <label className="d-flex align-items-center gap-6 user-select-none">
                                                    <div className="custom_check_box d-flex">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input m-0 p-0"
                                                            checked={!!selectedItemsOther["chiefComplaint"]}
                                                            onChange={() => toggleItem("chiefComplaint")}
                                                        />
                                                    </div>
                                                    <p className="text fs-13">Chief Complaint</p>
                                                </label>
                                        </div>
                                        <div className="d-flex flex-column gap-2">
                                                <label className="d-flex align-items-center gap-6 user-select-none">
                                                    <div className="custom_check_box d-flex">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input m-0 p-0"
                                                            checked={!!selectedItemsOther["historyofPresentIllness"]}
                                                            onChange={() => toggleItem("historyofPresentIllness")}
                                                        />
                                                    </div>
                                                    <p className="text fs-13">History of Present Illness</p>
                                                </label>
                                        </div>
                                        <div className="d-flex flex-column gap-2">
                                                <label className="d-flex align-items-center gap-6 user-select-none">
                                                    <div className="custom_check_box d-flex">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input m-0 p-0"
                                                            checked={!!selectedItemsOther["reviewOfSystem"]}
                                                            onChange={() => toggleItem("reviewOfSystem")}
                                                        />
                                                    </div>
                                                    <p className="text fs-13">Review Of System</p>
                                                </label>
                                        </div> */}

                                        {/* Objective */}
                                        {/* <div className="d-flex flex-column gap-2">
                                                <label className="d-flex align-items-center gap-6 user-select-none">
                                                    <div className="custom_check_box d-flex">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input m-0 p-0"
                                                            checked={!!selectedItemsOther["vitals"]}
                                                            onChange={() => toggleItem("vitals")}
                                                        />
                                                    </div>
                                                    <p className="text fs-13">Vitals</p>
                                                </label>
                                        </div> */}

                                        {/* Assessment */}
                                        {/* <div className="d-flex flex-column gap-2">
                                                <label className="d-flex align-items-center gap-6 user-select-none">
                                                    <div className="custom_check_box d-flex">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input m-0 p-0"
                                                            checked={!!selectedItemsOther["problems"]}
                                                            onChange={() => toggleItem("problems")}
                                                        />
                                                    </div>
                                                    <p className="text fs-13">Problems</p>
                                                </label>
                                        </div> */}
                                    </div>
                                    {/* Right Column */}
                                    {/* <div className="d-flex flex-column row-gap-12"> */}
                                        {/* Plan */}
                                        {/* <div className="d-flex flex-column gap-2">
                                                <label className="d-flex align-items-center gap-6 user-select-none">
                                                    <div className="custom_check_box d-flex">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input m-0 p-0"
                                                            checked={!!selectedItemsOther["otherNote"]}
                                                            onChange={() => toggleItem("otherNote")}
                                                        />
                                                    </div>
                                                    <p className="text fs-13">Notes</p>
                                                </label>
                                        </div> */}
                                        
                                        {/* Follow Up */}
                                        {/* <div className="d-flex flex-column gap-2">
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsOther["followUp"]}
                                                        onChange={() => toggleItem("followUp")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Follow-Up</p>
                                            </label>
                                        </div> */}

                                        {/* Additional Info */}
                                        {/* <div className="d-flex flex-column gap-2">
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsOther["additionalInfo"]}
                                                        onChange={() => toggleItem("additionalInfo")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Additional Info</p>
                                            </label>
                                            <div className="child d-flex flex-column gap-2">
                                                <label className="d-flex align-items-center gap-6 user-select-none">
                                                    <div className="custom_check_box d-flex">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input m-0 p-0"
                                                            checked={!!selectedItemsOther["documents"]}
                                                            onChange={() => toggleItem("documents")}
                                                        />
                                                    </div>
                                                    <p className="text fs-13">Documents</p>
                                                </label>
                                                <label className="d-flex align-items-center gap-6 user-select-none">
                                                    <div className="custom_check_box d-flex">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input m-0 p-0"
                                                            checked={!!selectedItemsOther["additionalNotes"]}
                                                            onChange={() => toggleItem("additionalNotes")}
                                                        />
                                                    </div>
                                                    <p className="text fs-13">Notes</p>
                                                </label>
                                            </div>
                                        </div> */}

                                        {/* Procedure Codes */}
                                        {/* <div>
                                            <label className="d-flex align-items-center gap-6 user-select-none">
                                                <div className="custom_check_box d-flex">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItemsOther["procedureCodes"]}
                                                        onChange={() => toggleItem("procedureCodes")}
                                                    />
                                                </div>
                                                <p className="text fs-13">Procedure Codes</p>
                                            </label>
                                        </div> */}
                                    {/* </div> */}
                                </div>}
                                </div> 
                                // : <></>
                                }
                            </>)
                        }) : <></>}
                    </div>
                    </>
                </Modal.Body>
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light ar_footer justify-content-between">
                    
                    <div>
                        <label className="d-flex align-items-center gap-6 user-select-none">
                            <div className="custom_check_box d-flex">
                                <input
                                    type="checkbox"
                                    className="form-check-input m-0 p-0"
                                    checked={selectedItemsUIView}
                                    onChange={() => setSelectedItemsUIView(prev => !prev)}
                                />
                            </div>
                            <p className="text fs-13 lh-12">Black and White</p>
                        </label>
                    </div>

                    <div className="btns-group">
                        <button className="btn btn-validate px-10 h-100 d-flex align-items-center gap-1" onClick={handleProceed}>
                            Proceed
                            <i className="icon-Symbol-24--25 text-white fs-12"></i>
                        </button>
                    </div>
                </div>

            </Modal>
        </>
    )
}

export default PrintOutSelectDataModal